import { normalize } from 'normalizr';
import * as schema from '../schema';
import * as actionTypes from './actionTypes';
import { axiosProtected, axiosDownload } from '../../axios-wizard';
import FileDownload from 'js-file-download'
import * as actions from '../../store/actions/index';
import { currentLang } from './support';

export const downloadProjectPdf = (projectId, projectTitle) => {
    const url = '/api/projects/' + projectId + '/print' +
    '?locale=' + currentLang()

    const today = new Date();

    const title = actions.slugify(projectTitle);

    const filename = title + "_" + today.toISOString().slice(0, 10) + ".pdf";

    return dispatch => {

        return axiosDownload.get( url )
            .then( response => {
               FileDownload(response.data, filename);
            } );
    };
};

export const downloadAngebotskalkulationPdf = (projectId, projectTitle) => {
    const url = '/api/print_angebotskalkulation?project_id=' + projectId +
    '&locale=' + currentLang()

    const today = new Date();

    const title = actions.slugify(projectTitle);

    const filename = title + "_" + today.toISOString().slice(0, 10) + ".pdf";

    return dispatch => {

        return axiosDownload.get( url )
            .then( response => {
               FileDownload(response.data, filename);
            } );
    };
};

export const reactivateProject = (projectId) => {
    const url = '/api/projects/' + projectId + '/reactivate'
    return dispatch => {
        dispatch({
          type: actionTypes.REACTIVATE_PROJECT_START
        });
        return axiosProtected.post( url )
            .then( response => {
               const normalizedProject = normalize(response.data, { project: schema.project })
               dispatch({
                 type: actionTypes.REACTIVATE_PROJECT_SUCCESS
               });
               dispatch(fetchProjectSuccess(normalizedProject));
            } )
            .catch( error => {
                dispatch({
                  type: actionTypes.REACTIVATE_PROJECT_FAILED
                });
            } );
    };
};


export const deactivateProject = (projectId) => {
    const url = '/api/projects/' + projectId + '/deactivate'
    return dispatch => {
        dispatch({
          type: actionTypes.DEACTIVATE_PROJECT_START
        });
        return axiosProtected.post( url )
            .then( response => {
               const normalizedProject = normalize(response.data, { project: schema.project })
               dispatch({
                 type: actionTypes.DEACTIVATE_PROJECT_SUCCESS
               });
               dispatch(fetchProjectSuccess(normalizedProject));
            } )
            .catch( error => {
                dispatch({
                  type: actionTypes.DEACTIVATE_PROJECT_FAILED
                });
            } );
    };
};


export const cloneProject = (values, projectId) => {
    const url = '/api/projects/' + projectId + '/clone'
    return dispatch => {
        dispatch({
          type: actionTypes.CLONE_PROJECT_START
        });
        return axiosProtected.post( url, values )
            .then( response => {
               const normalizedProject = normalize(response.data, { project: schema.project })
               dispatch({
                 type: actionTypes.CLONE_PROJECT_SUCCESS
               });
               dispatch(fetchProjectSuccess(normalizedProject));
            } )
            .catch( error => {
                dispatch({
                  type: actionTypes.CLONE_PROJECT_FAILED
                });
            } );
    };
};



export const allProjectsSorted = (state) => {
  return getAllProjects(state).sort((a,b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
}

export const getAllProjects = (state) => {
  if (state.inventory.projects !== undefined) {
    return Object.values(state.inventory.projects);
  } else {
    return [];
  }
}

export const fetchProjectsStart = (  ) => {
    return {
        type: actionTypes.FETCH_PROJECTS_START
    };
};

export const fetchProjectsSuccess = ( projects ) => {
    return {
        type: actionTypes.FETCH_PROJECTS_SUCCESS,
        values: projects,
        loading_projects: false
    };
};

export const fetchProjectsFailed = () => {
    return {
        type: actionTypes.FETCH_PROJECTS_FAILED
    };
};

export const initProjects = () => {
    const url = '/api/projects/'

    return dispatch => {
        dispatch( fetchProjectsStart() );
        axiosProtected.get( url )
            .then( response => {
               const normalizedProjects = normalize(response.data, { projects: schema.arrayOfProjects })
               dispatch(fetchProjectsSuccess(normalizedProjects));
            } )
            .catch( error => {
                dispatch(fetchProjectsFailed());
            } );
    };
};


export const getProject = (state, projectId) => {
  if (state.inventory !== undefined && state.inventory.projects !== undefined) {
    const x = Object.values(state.inventory.projects).filter(x => x.id === projectId);
    return (Array.isArray(x))? x[0] : undefined;
  } else {
    return [];
  }
}


export const fetchProjectStart = (  ) => {
    return {
        type: actionTypes.FETCH_PROJECT_START
    };
};

export const fetchProjectSuccess = ( projects ) => {
    return {
        type: actionTypes.FETCH_PROJECT_SUCCESS,
        values: projects
    };
};

export const fetchProjectFailed = () => {
    return {
        type: actionTypes.FETCH_PROJECT_FAILED
    };
};

export const initProject = (projectId) => {
    const url = '/api/projects/' + projectId

    return dispatch => {
        dispatch( fetchProjectStart() );
        return axiosProtected.get( url )
            .then( response => {
               const normalizedProject = normalize(response.data, { project: schema.project })
               dispatch(fetchProjectSuccess(normalizedProject));
               return projectId
;            } )
            .catch( error => {
                dispatch(fetchProjectFailed());
            } );
    };
};


export const saveProjectStart = (  ) => {
    return {
        type: actionTypes.SAVE_PROJECT_START
    };
};

const saveProjectSuccess = ( projects ) => {
    return {
        type: actionTypes.SAVE_PROJECT_SUCCESS,
        values: projects
    };
};

const saveProjectFailed = () => {
    return {
        type: actionTypes.SAVE_PROJECT_FAILED
    };
};


export const saveProject = (project) => {
    const url = '/api/projects'

    return dispatch => {
        dispatch( saveProjectStart() );
        return axiosProtected.post( url, project )
            .then( response => {
               const normalizedProject = normalize(response.data, { projects: schema.arrayOfProjects })
               dispatch(saveProjectSuccess(normalizedProject));
            } )
            .catch( error => {
                dispatch(saveProjectFailed());
            } );
    };
};


export const deleteProjectStart = (  ) => {
    return {
        type: actionTypes.DELETE_PROJECT_START
    };
};

const deleteProjectSuccess = ( projectId) => {
    return {
        type: actionTypes.DELETE_PROJECT_SUCCESS,
        projectId: projectId
    };
};

const deleteProjectFailed = () => {
    return {
        type: actionTypes.DELETE_PROJECT_FAILED
    };
};


export const deleteProject= (projectId) => {
    const url = '/api/projects/' + projectId
    return dispatch => {
        dispatch( deleteProjectStart() );
        return axiosProtected.delete( url )
            .then( response => {
               dispatch(deleteProjectSuccess(projectId));
            } )
            .catch( error => {
                dispatch(deleteProjectFailed());
            } );
    };
};



export const updateProjectStart = (  ) => {
    return {
        type: actionTypes.UPDATE_PROJECT_START
    };
};

const updateProjectSuccess = ( projects ) => {
    return {
        type: actionTypes.UPDATE_PROJECT_SUCCESS,
        values: projects
    };
};

const updateProjectFailed = () => {
    return {
        type: actionTypes.UPDATE_PROJECT_FAILED
    };
};


export const updateProject = (project) => {
    const url = '/api/projects/' + project.id

    return dispatch => {
        dispatch( updateProjectStart() );
        return axiosProtected.put( url, project )
            .then( response => {
               const normalizedProject = normalize(response.data, { project: schema.project })
               dispatch(updateProjectSuccess(normalizedProject));
            } )
            .catch( error => {
                dispatch(updateProjectFailed());
            } );
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/projects.js